import React, { useContext } from 'react';
import { Edit as EditIcon } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { FUND_TYPE } from 'common/constants/pageTypes';
import { LayoutContextValues } from 'common/types/store';
import { LayoutContext } from 'context';
import { getStringValue } from 'utilities';
import { EDIT_BUTTON_CLASSNAME, StyledTitle } from './styles';
import { TitleProps } from './types';

const EDIT_BUTTON_TOOLTIP = 'Edit';

const EditButton = () => {
  const { toggleMainForm } = useContext(LayoutContext) as unknown as LayoutContextValues;

  return (
    <Tooltip arrow title={EDIT_BUTTON_TOOLTIP}>
      <IconButton
        className={EDIT_BUTTON_CLASSNAME}
        data-testid="title-edit-button"
        onClick={toggleMainForm}
        size="small">
        <EditIcon color="primary" fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

const Title = ({ pageTitle }: TitleProps) => {
  const { pageType } = useContext(LayoutContext) as unknown as LayoutContextValues;

  return (
    <StyledTitle variant="h1">
      {pageTitle}
      {getStringValue(pageType) === FUND_TYPE && <EditButton />}
    </StyledTitle>
  );
};

export default Title;
